<template>
    <div v-if="user" class="d-flex align-items-center" :class="pullRight ? 'justify-content-end' : 'justify-content-center'">
        
        <div class="text-center text-nowrap">
            <div v-if="showAbsoluteTimestamp">{{ timestamp | timestamp_time_date }}</div>
            <timestamp v-else :timestamp="timestamp" />
            <div :class="{'deleted text-muted text-nowrap': user.deleted }">by {{ user.name || user.email_address }}</div>
        </div>
        <div class="ml-2" v-if="user.avatar_url && !hideAvatar">
            <img class="fit-cover thumb32 rounded-circle shadow-z2" :src="is_client_space_logo ? Utils.client_space_logo_src(user.avatar_url) : user.avatar_url" />
        </div>
    </div>
    <div v-else>
        <i class="ion-load-c spin"></i>
    </div>
</template>

<script>

import { Utils } from '@/helpers/utils.js'
import timestamp from './timestamp.vue'

export default {

    // 'externalActor' is a user object (name, avatar url) who is displayed when user ID is set to 0
    // This is the person who is not a Skyflok user, but their action is displayed, most probably a Client Space client
    props: {
        team: Array,
        userId: Number,
        timestamp: [Date, Number],
        
        pullRight: {
            type: Boolean,
            default: false
        },

        // A user object (name/email_address, avatar_url) who is displayed when userId=0 (e.g., Space Client, Share recipient)
        externalActor: {
            type: [Object, null],
            default: () => null
        },

        hideAvatar: {
            type: Boolean,
            default: false
        },

        showAbsoluteTimestamp: {
            type: Boolean,
            default: false
        }
    },
    
    
    components: {
        timestamp
    },

    data(){
        return{
            user: null,
            Utils: Utils
        }
    },

    computed: {
        is_client_space_logo(){
            return this.user.avatar_url.includes('client_space_logos')
        }
    },

    watch: {
        userId(){
            this.init()
        },
        team(){
            this.init()
        },
        timestamp(){
            this.init()
        },
    },

    mounted(){
        this.init()
    },

    methods: {
        init(){
            if(this.userId === undefined || this.team === undefined || this.timestamp === undefined){
                return;
            }
            
            if(this.userId <=0 && this.externalActor){
                this.user = structuredClone(this.externalActor)
                return
            }
            let user = this.team.find(m => { const id = m.user_id || m.id; return id == this.userId });
            if(user == undefined){
                user = { name:  "[deleted]", avatar_url: false, deleted: true }
            }
            else{
                user.avatar_url = Utils.avatar_url(user)
            }
            
            this.user = user
        }
    },
}
</script>

<style scoped>

.modified_box.pull-right{
    justify-content: flex-end;
}
.deleted{
    font-style: italic
}
</style>
